import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitFormData, setConfigToColumns } from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType";
import SnButton from "@shared/components/SnButton";
import SnResizeBar from "@shared/components/SnResizeBar";
import { RowNode } from "ag-grid-community";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { showResizablePopupModal } from "@widgets/CommonModal";
import SN_PUR_POR_REG_002_POP_01 from "./SN_PUR_POR_REG_002_POP_01";

interface Props {
  Menuprops: menuInfo;
}

const SN_PUR_POR_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [selectedDocu, setSelectedDocu] = useState<string>("");

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData(rtn.formData);
        const configGrid1 = setConfigToColumns(rtn.grid.grid2, "MAS0002");
        const configGrid2 = setConfigToColumns(configGrid1, "PUR0105");
        setColums({
          grid1: rtn.grid.grid1,
          grid2: configGrid2,
        });

        setFormData((prevData: any) => ({
          ...prevData,
          cd_module: Menuprops.cd_module,
        }));
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved = await onSave();
        if (!isSaved) return;
      }
    }

    try {
      const params = {
        id: "sn_pur_por_reg_002_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
      });
    } catch (error: any) {}
  };

  const onSave = async (msg?: string) => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      gridRefs.current["grid2"].current.stopEditing();

      const purPohChanges = gridRefs.current["grid1"].current.getChange();
      const purPolChanges = gridRefs.current["grid2"].current.getChange();
      const headerInserts = purPohChanges.insert ?? [];
      const lineInserts = purPolChanges.insert ?? [];

      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog("alter", "저장에 실패했습니다.");
        return false;
      }
      if (
        purPohChanges.modifiedRowcount === 0 &&
        purPolChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      const saveData = {
        pur_poh: purPohChanges,
        pur_pol: purPolChanges,
      };
      const ok = await fnSave("SN_PUR_POR_REG_002_SAVE_01", saveData, msg);
      if (!ok) return;

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      return false;
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_po = selectedRow.no_po;
      gridRefs.current["grid2"].current.applyFilters({ no_po });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
      setSelectedDocu(no_po);
    } else {
      return;
    }
  };

  const onGrid1BtnClick = async (id: any) => {
    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount === 0) return;

    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const displayedNodes: any[] = [];
    gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
      displayedNodes.push(node);
    });
    if (displayedNodes.length < 1) return;
    let chk = false;
    let msg = "";
    try {
      if (id === "aButton_PoApp") {
        const confirm = await showDialog("confirm", "승인처리 하시겠습니까?");
        if (!confirm) return;

        for (const node of displayedNodes) {
          if (node.data.st_po === "F") {
            gridRefs.current["grid2"].current.setValueImmediately(
              node,
              "st_po",
              "R"
            );
            //
            //node.setDataValue("st_po", "R");
            chk = true;
          }
        }
        if (!chk) {
          await showDialog("alter", "처리 실패. 미승인건이 없습니다.");
          return;
        }
        gridRefs.current["grid1"].current.setValueImmediately(
          focusedNodeH,
          "st_po",
          "R"
        );
        //focusedNodeH.setDataValue("st_po", "R");

        msg = "APPROVE";

        const purPohChanges = gridRefs.current["grid1"].current.getChange();
        const purPolChanges = gridRefs.current["grid2"].current.getChange();
        const saveData = {
          pur_poh: purPohChanges,
          pur_pol: purPolChanges,
        };
        const ok = await fnSave("SN_PUR_POR_REG_002_SAVE_01", saveData, msg);
        if (!ok) return;

        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
        onSearch();
        // onSave(msg);
      }
      if (id === "aButton_PoCancel") {
        if (focusedNodeH.data?.yn_app === "Y") {
          await showDialog(
            "alter",
            "발주형태 '자동승인' 건은 취소할 수 없습니다."
          );
          return;
        }

        let isP = false;
        for (const node of displayedNodes) {
          if (!isP && node.data.st_po === "P") {
            isP = true;
          }

          if (node.data.st_po === "R") {
            gridRefs.current["grid2"].current.setValueImmediately(
              node,
              "st_po",
              "F"
            );
            chk = true;
            msg = "APPROVE_CANCEL";
          }
        }
        if (!chk) {
          await showDialog("alter", "처리 실패. 승인건이 없습니다.");
          return;
        }

        if (isP) {
          gridRefs.current["grid1"].current.setValueImmediately(
            focusedNodeH,
            "st_po",
            "P"
          );
          //focusedNodeH.setDataValue("st_po", "P");
        } else {
          gridRefs.current["grid1"].current.setValueImmediately(
            focusedNodeH,
            "st_po",
            "F"
          );
          //focusedNodeH.setDataValue("st_po", "F");
        }
        onSave(msg);
      }
    } catch (error: any) {}
  };

  const onGrid2BtnClick = async (id: string) => {
    try {
      switch (id) {
        case "aButton_Confirm":
          grid2button1();
          break;

        case "aButton_Cancel":
          grid2button2();
          break;

        case "aButton_Close": // is not working properly
          grid2button3();
          break;

        case "aButton_CloseCancel":
          grid2button4();
          break;
      }
    } catch {}
  };

  const grid2button1 = async () => {
    let msg = "";
    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount === 0) return;

    const headerNode = gridRefs.current["grid1"].current.focusedRowNode();
    const displayedNodes: any[] = [];
    gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
      displayedNodes.push(node);
    });

    let updated = false;
    for (const node of displayedNodes) {
      if (!node?.data || !node.isSelected()) continue;

      const st_po = String(node.data.st_po ?? "");
      switch (st_po) {
        case "P":
          await showDialog("alter", "확정된 건만 승인 가능합니다.");
          return;
        case "R":
          await showDialog("alter", "이미 승인 처리된 건입니다.");
          return;
        case "S":
          await showDialog("alter", "승인 처리 후 진행중인 건 입니다.");
          return;
        case "C":
          await showDialog("alter", "마감된 건 입니다.");
          return;
        case "X":
          await showDialog("alter", "전표 취소된 건 입니다.");
          return;
      }

      if (st_po === "F") {
        gridRefs.current["grid2"].current.setValueImmediately(
          node,
          "st_po",
          "R"
        );
        // node.setDataValue("st_po", "R");
        updated = true;
        msg = "APPROVE";
      }
    }
    if (!updated) return;

    const allRowsNowR = displayedNodes.every(
      (node: any) => String(node.data.st_po ?? "") === "R"
    );
    if (allRowsNowR && headerNode) {
      const header_st_po = String(headerNode.data.st_po ?? "");
      if (header_st_po === "F") {
        gridRefs.current["grid1"].current.setValueImmediately(
          headerNode,
          "st_po",
          "R"
        );
        //headerNode.setDataValue("st_po", "R");
      }
    }
    onSave(msg);
  };

  const grid2button2 = async () => {
    let msg = "";
    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount === 0) return;

    const headerNode = gridRefs.current["grid1"].current.focusedRowNode();
    const displayedNodes: any[] = [];
    gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
      displayedNodes.push(node);
    });

    let updated = false;
    for (const node of displayedNodes) {
      if (!node?.data || !node.isSelected()) continue;
      if (node.isSelected()) {
        const st_po = String(node.data.st_po ?? "");
        switch (st_po) {
          case "P":
            return;
          case "F":
            await showDialog("alter", "승인되지 않은 건 입니다.");
            return;
          case "S":
            await showDialog("alter", "진행중인 건은 승인 취소할 수 없습니다.");
            return;
          case "C":
            await showDialog("alter", "마감된 건은 승인 취소할 수 없습니다.");
            return;
          case "X":
            await showDialog("alter", "이미 전표 취소된 건 입니다.");
            return;
        }
        if (node.data.yn_app === "Y") {
          await showDialog(
            "alter",
            "발주형태 '자동승인' 건은 취소할 수 없습니다."
          );
          return;
        }

        if (st_po === "R") {
          gridRefs.current["grid2"].current.setValueImmediately(
            node,
            "st_po",
            "F"
          );
          // node.setDataValue("st_po", "F");
          updated = true;
          msg = "APPROVE_CANCEL";
        }
      }
      if (!updated) return;

      const allRowsNowR = displayedNodes.every(
        (node: any) => String(node.data.st_po ?? "") === "F"
      );
      if (allRowsNowR && headerNode) {
        const header_st_po = String(headerNode.data.st_po ?? "");
        if (header_st_po === "R") {
          gridRefs.current["grid1"].current.setValueImmediately(
            headerNode,
            "st_po",
            "F"
          );
          // headerNode.setDataValue("st_po", "F");
        }
      }
    }
    onSave(msg);
  };

  const grid2button3 = async () => {
    let msg = "";
    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount === 0) return;

    const headerNode = gridRefs.current["grid1"].current.focusedRowNode();
    const displayedNodes: any[] = [];
    gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
      displayedNodes.push(node);
    });
    const selectedNodes = displayedNodes.filter(
      (node: any) => node?.data && node.isSelected()
    );
    for (const node of selectedNodes) {
      const dc_reason_close = String(node.data.dc_reason_close ?? "");
      const st_po = String(node.data.st_po ?? "");
      if (st_po !== "C" && dc_reason_close === "") {
        await showDialog("alter", "종결사유를 입력하시기 바랍니다.");
        gridRefs.current["grid2"].current.setFocusedCell(
          node.rowIndex,
          "dc_reason_close"
        );
        return;
      }
    }

    let anyUpdated = false;
    for (const node of selectedNodes) {
      const st_po = String(node.data.st_po ?? "");
      if (st_po !== "C") {
        gridRefs.current["grid2"].current.setValueImmediately(
          node,
          "st_po",
          "C"
        );
        // node.setDataValue("st_po", "C");
        anyUpdated = true;
        msg = "CLOSE";
      } else {
        await showDialog("alter", "이미 마감처리된 건 입니다.");
        return;
      }
    }

    const allStPo = displayedNodes.map((node: any) =>
      String(node.data.st_po ?? "")
    );
    const allC = allStPo.every((v: any) => v === "C");
    const hasC = allStPo.includes("F");
    const hasR = allStPo.includes("R");
    if (headerNode) {
      if (allC) {
        gridRefs.current["grid1"].current.setValueImmediately(
          headerNode,
          "st_po",
          "C"
        );
        // headerNode.setDataValue("st_po", "C");
      } else if (hasC || hasR) {
        gridRefs.current["grid1"].current.setValueImmediately(
          headerNode,
          "st_po",
          "S"
        );
        // headerNode.setDataValue("st_po", "S");
      }
    }
    if (anyUpdated) {
      onSave(msg);
    }
  };

  const grid2button4 = async () => {
    let msg = "";
    const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
    if (rowCount === 0) return;

    const headerNode = gridRefs.current["grid1"].current.focusedRowNode();
    const displayedNodes: any[] = [];
    gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
      displayedNodes.push(node);
    });
    const yn_app = headerNode?.data?.yn_app ?? "";

    for (const node of displayedNodes) {
      if (!node?.data || !node.isSelected()) continue;

      const st_po = String(node.data.st_po ?? "");
      const qt_req = Number(node.data.qt_req ?? 0);
      if (st_po === "C") {
        if (qt_req > 0) {
          gridRefs.current["grid2"].current.setValueImmediately(
            node,
            "st_po",
            "S"
          );
          // node.setDataValue("st_po", "S");
          gridRefs.current["grid1"].current.setValueImmediately(
            headerNode,
            "st_po",
            "S"
          );
          // headerNode.setDataValue("st_po", "S");
        } else if (qt_req === 0) {
          if (yn_app === "Y") {
            gridRefs.current["grid2"].current.setValueImmediately(
              node,
              "st_po",
              "R"
            );
            // node.setDataValue("st_po", "R");
            gridRefs.current["grid1"].current.setValueImmediately(
              headerNode,
              "st_po",
              "R"
            );
            // headerNode.setDataValue("st_po", "R");
          } else {
            gridRefs.current["grid2"].current.setValueImmediately(
              node,
              "st_po",
              "F"
            );
            // node.setDataValue("st_po", "F");
            gridRefs.current["grid1"].current.setValueImmediately(
              headerNode,
              "st_po",
              "F"
            );
            // headerNode.setDataValue("st_po", "F");
          }
        }
        msg = "CLOSE_CANCEL";
      } else {
        await showDialog("alter", "마감처리 되지 않는 건입니다.");
        return;
      }
    }
    onSave(msg);
  };

  const handleContextMenu = async (event: any) => {
    const id = event.id;
    const menu = event.menu;
    switch (id) {
      case "applyApprove":
        grid2button1();
        break;
      case "cancleApprove":
        grid2button2();
        break;
      case "devideQt":
        await devideQt();
        break;
      case "applyClose":
        await grid2button3();
        break;
      case "cancelClose":
        await grid2button4();
        break;
    }
  };

  const devideQt = async () => {
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const focusedNodeL = gridRefs.current["grid2"].current.focusedRowNode();
    if (focusedNodeL.data.qt - focusedNodeL.data.qt_req === 0) {
      await showDialog("alter", "분할 대상수량이 없습니다.");
      return;
    }
    if (focusedNodeL.data.st_po === "C") {
      await showDialog("alter", "이미 마감처리된 건입니다.");
      return;
    }

    const selectedData = {
      ...focusedNodeL?.data,
      fg_trns: focusedNodeH.data.fg_trns,
      rt_exch: focusedNodeH.data.rt_exch,
      cd_exch: focusedNodeH.data.cd_exch,
    };
    const maxNoLine =
      gridRefs.current["grid2"]?.current?.getMaxValue("no_line");
    const component = (
      <SN_PUR_POR_REG_002_POP_01
        selectedData={selectedData}
        maxNoLine={maxNoLine}
      />
    );
    const result = await showResizablePopupModal({
      title: "잔량분할",
      children: component,
      width: "1070px",
      height: "570px",
      validation: true,
    });
    if (!result || result === "close") return;

    const insertList = result[0].insert;
    for (const i of insertList) {
      gridRefs.current["grid2"].current.addRow(i);
    }

    const updateList = result[0].update;
    // const updateRow = updateList[0];
    // Object.keys(updateRow).forEach((key) => {
    //   focusedNodeL.setDataValue(key, updateRow[key], "noEvent");
    // });
    focusedNodeL.setData({
      ...focusedNodeL.data,
      ...updateList[0],
    });

    gridRefs.current["grid1"].current.resetUpdate();
    gridRefs.current["grid2"].current.resetUpdate();
  };

  const applyClose = async () => {
    const focusedRowNodeL = gridRefs.current["grid2"].current.focusedRowNode();
    if (focusedRowNodeL.data.st_po === "C") {
      await showDialog("alter", "이미 마감처리된 건입니다.");
      return;
    }

    gridRefs.current["grid2"].current.setValueImmediately(
      focusedRowNodeL,
      "st_po",
      "C"
    );
    return await onSave("CLOSE");
  };

  const cancelClose = async () => {
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const yn_app = focusedNodeH?.data?.yn_app ?? "";

    const focusedRowNodeL = gridRefs.current["grid2"].current.focusedRowNode();
    if (focusedRowNodeL.data.st_po !== "C") {
      await showDialog("alter", "마감처리 되지 않는 건입니다.");
      return;
    }

    const qt_req = Number(focusedRowNodeL.data.qt_req ?? 0);
    if (qt_req > 0) {
      gridRefs.current["grid2"].current.setValueImmediately(
        focusedRowNodeL,
        "st_po",
        "S"
      );
    } else if (qt_req === 0) {
      if (yn_app === "Y") {
        gridRefs.current["grid2"].current.setValueImmediately(
          focusedRowNodeL,
          "st_po",
          "R"
        );
      } else {
        gridRefs.current["grid2"].current.setValueImmediately(
          focusedRowNodeL,
          "st_po",
          "F"
        );
      }
    }
    return await onSave("CLOSE_CANCEL");
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onContextMenu: handleContextMenu,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "발주정보" }}
            events={grids.grid1.events}
            header={
              <div>
                <SnButton
                  text={"발주별승인"}
                  onClick={() => {
                    onGrid1BtnClick("aButton_PoApp");
                  }}
                />
                <SnButton
                  text={"발주별승인취소"}
                  onClick={() => {
                    onGrid1BtnClick("aButton_PoCancel");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]}
            columnConfig={grids.grid2.columns}
            rowData={grids.grid2.dataSource}
            etcProps={{ rowSelection: "multiple", title: "상세정보" }}
            events={grids.grid2.events}
            header={
              <div>
                <SnButton
                  text={"승인처리"}
                  onClick={() => {
                    onGrid2BtnClick("aButton_Confirm");
                  }}
                />
                <SnButton
                  text={"승인취소"}
                  onClick={() => {
                    onGrid2BtnClick("aButton_Cancel");
                  }}
                />
                <SnButton
                  text={"마감처리"}
                  onClick={() => {
                    onGrid2BtnClick("aButton_Close");
                  }}
                />
                <SnButton
                  text={"마감취소"}
                  onClick={() => {
                    onGrid2BtnClick("aButton_CloseCancel");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PUR_POR_REG_002;
